/**
 * Крошечный pub-sub store. Listener получает ПОЛНОЕ новое состояние на каждом изменении.
 * Без селекторов, без deep-equal — состояние маленькое (≤8 ключей), ре-рендеры
 * O(state-keys) на изменение. Держит bundle небольшим.
 *
 * @template T
 * @param {T} initial
 * @returns {{ get: () => T, set: (patch: Partial<T>) => void, subscribe: (fn: (s: T) => void) => () => void }}
 */
export function createStore(initial) {
    let state = initial;
    const listeners = new Set();

    return {
        get: () => state,
        set: (patch) => {
            state = { ...state, ...patch };
            listeners.forEach(fn => fn(state));
        },
        subscribe: (fn) => {
            listeners.add(fn);
            return () => listeners.delete(fn);
        },
    };
}
